import { logEvent } from './logGaEvent'

const logPageView = ({ pageType, bundle }) => {
  logEvent('page_view', {
    product_name: 'air',
    page_name: pageType,
    bundle_flag: bundle?.flag,
    bundle_type: bundle?.type,
  })
}

export { logPageView }
